<eif-custom-table
	[columns]="tableColumns"
	[rows]="validationResultRecords"
	[loading]="loading"
	[pagination]="pagination"
	[enableFilters]="enableFilters"
	[filters]="filters"
	[showPagination]="showPagination"
	[showPageSize]="showPageSize"
	(searchRequested)="searchRequested.emit($event)"
	[idField]="'RowNumber'"
	[cardTemplate]="validationResultCard"
	[expandTemplate]="validationErrorsExpand"
	[cardExpandTemplate]="validationErrorsExpand"
	#customTable>
</eif-custom-table>

<ng-template
	#validationResultCard
	let-row>
	<div class="eif-card">
		<div class="eif-card-header">
			<div class="label">{{ 'documents-upload-confirming-validation-result.ValidationStatus' | translate }}</div>
			<div>
				<span class="tag upload-doc-state-{{ row.ValidationStatus }}">
					{{ row.ValidationStatus | translate: 'list-uploadedDocumentRecordState' }}
				</span>
			</div>
		</div>
		<div class="eif-card-section">
			<div class="label">{{ 'documents-upload-confirming-validation-result.DocumentRecordsRow' | translate }}</div>
			<div>{{ row.RowNumber }}</div>
		</div>
		<div class="eif-card-section">
			<div class="label">{{ 'documents-upload-confirming-validation-result.DocumentRecordsDocType' | translate }}</div>
			<div>{{ row.Type }}</div>
		</div>
		<div class="eif-card-section">
			<div class="label">{{ 'documents-upload-confirming-validation-result.DocumentRecordsNumber' | translate }}</div>
			<div>{{ row.Number }}</div>
		</div>
		<div class="eif-card-section">
			<div class="label">{{ 'documents-upload-confirming-validation-result.DocumentRecordsTotalAmount' | translate }}</div>
			<div class="is-bold">{{ row.TotalAmount }}</div>
		</div>
		<div class="eif-card-section">
			<div class="label">{{ 'documents-upload-confirming-validation-result.DocumentRecordsCurrency' | translate }}</div>
			<div>{{ row.Currency }}</div>
		</div>
		<div class="eif-card-section">
			<div class="label">{{ 'documents-upload-confirming-validation-result.DocumentRecordsIssueDate' | translate }}</div>
			<div>{{ row.IssuedDate ? (row.IssuedDate | dateLocale: 'yyyy/MM/dd') : '' }}</div>
		</div>
		<div class="eif-card-section">
			<div class="label">{{ 'documents-upload-confirming-validation-result.DocumentRecordsDueDate' | translate }}</div>
			<div>{{ row.DueDate ? (row.DueDate | dateLocale: 'yyyy/MM/dd') : '' }}</div>
		</div>
		<div class="eif-card-section">
			<div class="label">{{ 'documents-upload-confirming-validation-result.DocumentRecordsBuyerPaymentDate' | translate }}</div>
			<div>{{ row.BuyerPaymentDate ? (row.BuyerPaymentDate | dateLocale: 'yyyy/MM/dd') : '' }}</div>
		</div>
		<div class="eif-card-section">
			<div class="label">{{ 'documents-upload-confirming-validation-result.DocumentRecordsBuyerVat' | translate }}</div>
			<div>{{ row.BuyerCountryCode }}{{ row.BuyerVat }}</div>
		</div>
		<div class="eif-card-section">
			<div class="label">{{ 'documents-upload-confirming-validation-result.DocumentRecordsSupplierVat' | translate }}</div>
			<div>{{ row.SupplierCountryCode }}{{ row.SupplierVat }}</div>
		</div>
	</div>
</ng-template>

<ng-template
	#validationErrorsExpand
	let-row>
	<div class="label">{{ 'documents-upload-confirming-validation-result.DocumentRecordsValidationErrors' | translate }}</div>
	<ul>
		@for (lineError of row.ValidationErrors; track $index) {
			@if (lineError?.Values[0]) {
				<li>
					{{ lineError?.Values[0] }}
				</li>
			}
		}
	</ul>
</ng-template>
